import React, { useState } from 'react';

export default function RoomHeader({ mode, roomId }) {
  const [copied, setCopied] = useState(false);

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(roomId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy room code:', err);
    }
  };

  return (
    <>
      <h2>Game {mode} Room</h2>
      <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: 12 }}>Share this code with friends</p>
      
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '12px', 
          marginBottom: '24px' 
        }}
      >
        <div className="room-code" style={{ margin: 0 }}>{roomId}</div>
        <button
          onClick={handleCopyCode}
          style={{
            padding: '10px 16px',
            background: copied ? 'rgba(5, 150, 105, 0.8)' : 'rgba(255,255,255,0.1)',
            border: copied ? '1px solid #6ee7b7' : '1px solid rgba(255,255,255,0.2)',
            borderRadius: '8px',
            color: 'white',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          {copied ? '✅ Copied!' : '📋 Copy'}
        </button>
      </div>
    </>
  );
}